import { styles as componentStyles } from './view.scss';
import { unsafeCSS } from 'lit';

import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';

// Risk management dependencies
import { styles as commonSideMenuStyle } from '../../../riskManagement/sideMenus/common/sideMenuCommon.scss';

export const styles = [
  unsafeCSS(`${commonSideMenuStyle}`),
  unsafeCSS(`${flexboxHelpersStyles}`),
  unsafeCSS(`${styleHelpers}`),
  unsafeCSS(`${textHelpersStyles}`),
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${componentStyles}`),
];
